import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Folder, FolderTree, IFolder, IFolderTreeNode, PlatformService } from 'buzzyears.ui';
import { ConciseContextTree, ContextTree, IContext } from 'buzzyears.core';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/mergeMap';

@Injectable()
export class WorkflowFolderService extends ApiService {

  constructor(http: HttpClient, platformService: PlatformService) {
    super(http, platformService);
  }

  getFolderTree(): Observable<FolderTree> {
    return this.list().map(foldersList => new FolderTree(
      <IFolderTreeNode[]>FolderTree.listToTree(foldersList, f => f.id)));
  }

  list(): Observable<any> {
    return this.http
      .post(this.toUrl('search'), {
        paging: {limit: 999999},
        sort: {
          createdAt: 'asc',
          _id: 'asc'
        }
      }, this.requestOptions)
      .map((raw: any) => raw.docs.map(r => new Folder(r)))
      .catch(this.manageError);
  }

  create(folder: IFolder): Observable<any> {
    return this.http
      .post(this.toUrl(), folder, this.requestOptions)
      .map((raw: any) => new Folder(raw))
      .catch(this.manageError);
  }

  update(data: IFolder): Observable<any> {
    return this.http
      .put(this.toUrl(), data, this.requestOptions)
      .map((raw: any) => new Folder(raw))
      .catch(this.manageError);
  }

  remove(id: string): Observable<any> {
    return this.http
      .delete(this.toUrl(id), this.requestOptions)
      .map((raw: any) => new Folder(raw))
      .catch(this.manageError);
  }

  getRaw(id: string): Observable<any> {
    return this.http
      .get(this.toUrl(id), this.requestOptions)
      .catch(this.manageError);
  }

  get(id: string): Observable<any> {
    return this.http
      .get(this.toUrl(id), this.requestOptions)
      .map((raw: any) => new Folder(raw))
      .catch(this.manageError);
  }

  protected toUrl(...parts: string[]): string {
    return super.toUrl('workflow-folder', ...parts);
  }

  contextTree(): Observable<ContextTree> {
    return this.platformService.getContext(this.platformService.activeUserId)
      .map(raw => new ConciseContextTree(raw));
  }

  get defaultContext(): IContext {
    return this.platformService.defaultContext;
  }

  getInFolder(folderId: any): Observable<any> {

    const root = !folderId,
      filter = root ? {
        $or: [
          {parent: null},
          {parent: ''}
        ]
      } : {parent: folderId};

    return this.http
      .post(this.toUrl('search'), {
        filter: filter,
        paging: {limit: 999999},
        sort: {
          createdAt: 'asc',
          _id: 'asc'
        }
      }, this.requestOptions)
      .map((raw: any) => raw.docs.map(r => new Folder(r)))
      .catch(this.manageError);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/workflow-folder.service.ts